const sample = [
    {
        "id": 1,
        "question": "Please select what sector you want to rate.",
        "response_type": "Radio",
        "answers": [
            {
                "id": 1,
                "answer": "Financial",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 1,
                "choice": null,
                "question": 1
            },
            {
                "id": 2,
                "answer": "Telecoms",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 2,
                "choice": null,
                "question": 1
            },
            {
                "id": 3,
                "answer": "Insurance",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 3,
                "choice": null,
                "question": 1
            },
            {
                "id": 4,
                "answer": "Healthcare",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 4,
                "choice": null,
                "question": 1
            },
            {
                "id": 5,
                "answer": "Transportation",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 5,
                "choice": null,
                "question": 1
            },
            {
                "id": 6,
                "answer": "Power",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 6,
                "choice": null,
                "question": 1
            },
            {
                "id": 7,
                "answer": "Online Shopping/E-commerce",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 7,
                "choice": null,
                "question": 1
            },
            {
                "id": 8,
                "answer": "Public Sector",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 8,
                "choice": null,
                "question": 1
            },
            {
                "id": 9,
                "answer": "Hospitality",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 9,
                "choice": null,
                "question": 1
            },
            {
                "id": 632,
                "answer": "Real Estate",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 10,
                "choice": null,
                "question": 1
            },
            {
                "id": 633,
                "answer": "Education",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 11,
                "choice": null,
                "question": 1
            },
            {
                "id": 634,
                "answer": "Sports/Gaming",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 12,
                "choice": null,
                "question": 1
            }
        ]
    },
    {
        "id": 2,
        "question": "Overall, how satisfied or dissatisfied are you with customer service in the SECTOR sub-sector in Nigeria?",
        "response_type": "RadioInline",
        "answers": [
            {
                "id": 12,
                "answer": "1",
                "answer_title": "{'begin': 'Extremely dissatisfied', 'end': 'Extremely satisfied'}",
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 2
            },
            {
                "id": 13,
                "answer": "2",
                "answer_title": "{'begin': 'Extremely dissatisfied', 'end': 'Extremely satisfied'}",
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 2
            },
            {
                "id": 14,
                "answer": "3",
                "answer_title": "{'begin': 'Extremely dissatisfied', 'end': 'Extremely satisfied'}",
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 2
            },
            {
                "id": 15,
                "answer": "4",
                "answer_title": "{'begin': 'Extremely dissatisfied', 'end': 'Extremely satisfied'}",
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 2
            },
            {
                "id": 16,
                "answer": "5",
                "answer_title": "{'begin': 'Extremely dissatisfied', 'end': 'Extremely satisfied'}",
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 2
            },
            {
                "id": 17,
                "answer": "6",
                "answer_title": "{'begin': 'Extremely dissatisfied', 'end': 'Extremely satisfied'}",
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 2
            },
            {
                "id": 18,
                "answer": "7",
                "answer_title": "{'begin': 'Extremely dissatisfied', 'end': 'Extremely satisfied'}",
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 2
            }
        ]
    },
    {
        "id": 3,
        "question": "Please select SECTOR_TITLE in the SECTOR sector that you have done business with in the last six (6) months, even if only once. If the COMPANY_TYPE is not listed, please type it in the space provided for Others.",
        "response_type": "Checkbox",
        "answers": [
            {
                "id": 19,
                "answer": "Access Bank",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 1,
                "choice": "1",
                "question": 3
            },
            {
                "id": 20,
                "answer": "GTBank",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 1,
                "choice": "1",
                "question": 3
            },
            {
                "id": 21,
                "answer": "Zenith Bank",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 1,
                "choice": "1",
                "question": 3
            },
            {
                "id": 22,
                "answer": "Fidelity Bank",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 1,
                "choice": "1",
                "question": 3
            },
            {
                "id": 23,
                "answer": "Union Bank",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 1,
                "choice": "1",
                "question": 3
            },
            {
                "id": 24,
                "answer": "Keystone Bank",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 1,
                "choice": "1",
                "question": 3
            },
            {
                "id": 25,
                "answer": "Polaris Bank",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 1,
                "choice": "1",
                "question": 3
            },
            {
                "id": 26,
                "answer": "First Bank",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 1,
                "choice": "1",
                "question": 3
            },
            {
                "id": 27,
                "answer": "Wema Bank",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 1,
                "choice": "1",
                "question": 3
            },
            {
                "id": 28,
                "answer": "Sterling Bank",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 1,
                "choice": "1",
                "question": 3
            },
            {
                "id": 29,
                "answer": "Paystack",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 1,
                "choice": "2",
                "question": 3
            },
            {
                "id": 30,
                "answer": "Paga",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 1,
                "choice": "2",
                "question": 3
            },
            {
                "id": 31,
                "answer": "PayAttitude",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 1,
                "choice": "2",
                "question": 3
            },
            {
                "id": 32,
                "answer": "Flutterwave",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 1,
                "choice": "2",
                "question": 3
            },
            {
                "id": 33,
                "answer": "Carbon",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 1,
                "choice": "2",
                "question": 3
            },
            {
                "id": 34,
                "answer": "Nomba",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 1,
                "choice": "2",
                "question": 3
            },
            {
                "id": 35,
                "answer": "Globalcom",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 2,
                "choice": "1",
                "question": 3
            },
            {
                "id": 36,
                "answer": "MTN",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 2,
                "choice": "1",
                "question": 3
            },
            {
                "id": 37,
                "answer": "Airtel",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 2,
                "choice": "1",
                "question": 3
            },
            {
                "id": 38,
                "answer": "9mobile",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 2,
                "choice": "1",
                "question": 3
            },
            {
                "id": 39,
                "answer": "Smile",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 2,
                "choice": "2",
                "question": 3
            },
            {
                "id": 40,
                "answer": "ipnx",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 2,
                "choice": "2",
                "question": 3
            },
            {
                "id": 41,
                "answer": "Spectranet",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 2,
                "choice": "2",
                "question": 3
            },
            {
                "id": 42,
                "answer": "Tizeti",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 2,
                "choice": "2",
                "question": 3
            },
            {
                "id": 43,
                "answer": "Globalcom",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 2,
                "choice": "2",
                "question": 3
            },
            {
                "id": 44,
                "answer": "MTN",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 2,
                "choice": "2",
                "question": 3
            },
            {
                "id": 45,
                "answer": "Airtel",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 2,
                "choice": "2",
                "question": 3
            },
            {
                "id": 46,
                "answer": "9mobile",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 2,
                "choice": "2",
                "question": 3
            },
            {
                "id": 47,
                "answer": "IGI",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 3,
                "choice": "1",
                "question": 3
            },
            {
                "id": 48,
                "answer": "Axa Mansard",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 3,
                "choice": "1",
                "question": 3
            },
            {
                "id": 49,
                "answer": "Heirs Insurance",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 3,
                "choice": "1",
                "question": 3
            },
            {
                "id": 50,
                "answer": "TANGERINE LIFE",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 3,
                "choice": "1",
                "question": 3
            },
            {
                "id": 51,
                "answer": "Anchor HMO",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 3,
                "choice": "2",
                "question": 3
            },
            {
                "id": 52,
                "answer": "Reliance HMO",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 3,
                "choice": "2",
                "question": 3
            },
            {
                "id": 53,
                "answer": "Avon HMO",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 3,
                "choice": "2",
                "question": 3
            },
            {
                "id": 54,
                "answer": "AXA HMO",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 3,
                "choice": "2",
                "question": 3
            },
            {
                "id": 55,
                "answer": "LUTH - Idi Araba",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 4,
                "choice": "1",
                "question": 3
            },
            {
                "id": 56,
                "answer": "UNTH -Enugu",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 4,
                "choice": "1",
                "question": 3
            },
            {
                "id": 57,
                "answer": "UITH - Ibadan",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 4,
                "choice": "1",
                "question": 3
            },
            {
                "id": 58,
                "answer": "LASUTH - Ikeja",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 4,
                "choice": "1",
                "question": 3
            },
            {
                "id": 59,
                "answer": "ABUTH - Bauchi",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 4,
                "choice": "1",
                "question": 3
            },
            {
                "id": 60,
                "answer": "ABUTH - Kano",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 4,
                "choice": "1",
                "question": 3
            },
            {
                "id": 61,
                "answer": "General Hospital - Gbagada",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 4,
                "choice": "1",
                "question": 3
            },
            {
                "id": 62,
                "answer": "UCTH - Calabar",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 4,
                "choice": "1",
                "question": 3
            },
            {
                "id": 63,
                "answer": "Military Hospital",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 4,
                "choice": "1",
                "question": 3
            },
            {
                "id": 64,
                "answer": "UniAbuja Teaching Hospital",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 4,
                "choice": "1",
                "question": 3
            },
            {
                "id": 65,
                "answer": "FMC Owerri",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 4,
                "choice": "1",
                "question": 3
            },
            {
                "id": 66,
                "answer": "FMC Umuahia",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 4,
                "choice": "1",
                "question": 3
            },
            {
                "id": 67,
                "answer": "Uniport Tech Hospital",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 4,
                "choice": "1",
                "question": 3
            },
            {
                "id": 68,
                "answer": "EKO Hospital",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 4,
                "choice": "2",
                "question": 3
            },
            {
                "id": 69,
                "answer": "Lagoon Hospital",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 4,
                "choice": "2",
                "question": 3
            },
            {
                "id": 70,
                "answer": "Surjen Hospital",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 4,
                "choice": "2",
                "question": 3
            },
            {
                "id": 71,
                "answer": "Duchess Hospital",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 4,
                "choice": "2",
                "question": 3
            },
            {
                "id": 72,
                "answer": "Reddington Hospital",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 4,
                "choice": "2",
                "question": 3
            },
            {
                "id": 73,
                "answer": "Airpeace",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 5,
                "choice": "1",
                "question": 3
            },
            {
                "id": 74,
                "answer": "Ibom Air",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 5,
                "choice": "1",
                "question": 3
            },
            {
                "id": 75,
                "answer": "Arik Air",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 5,
                "choice": "1",
                "question": 3
            },
            {
                "id": 76,
                "answer": "Dana Air",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 5,
                "choice": "1",
                "question": 3
            },
            {
                "id": 77,
                "answer": "ABC Transports",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 5,
                "choice": "2",
                "question": 3
            },
            {
                "id": 78,
                "answer": "God is Good",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 5,
                "choice": "2",
                "question": 3
            },
            {
                "id": 79,
                "answer": "The Young Shall Grow",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 5,
                "choice": "2",
                "question": 3
            },
            {
                "id": 80,
                "answer": "Libra Motors",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 5,
                "choice": "2",
                "question": 3
            },
            {
                "id": 81,
                "answer": "GUO Transport",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 5,
                "choice": "2",
                "question": 3
            },
            {
                "id": 82,
                "answer": "LAMATA",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 5,
                "choice": "3",
                "question": 3
            },
            {
                "id": 83,
                "answer": "BRT",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 5,
                "choice": "3",
                "question": 3
            },
            {
                "id": 84,
                "answer": "Bolt",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 5,
                "choice": "3",
                "question": 3
            },
            {
                "id": 85,
                "answer": "Uber",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 5,
                "choice": "3",
                "question": 3
            },
            {
                "id": 86,
                "answer": "InDrive",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 5,
                "choice": "3",
                "question": 3
            },
            {
                "id": 87,
                "answer": "Ikeja Electric (IKDC)",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 6,
                "choice": null,
                "question": 3
            },
            {
                "id": 88,
                "answer": "EKO Electric (EKDC)",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 6,
                "choice": null,
                "question": 3
            },
            {
                "id": 89,
                "answer": "Enugu Electric",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 6,
                "choice": null,
                "question": 3
            },
            {
                "id": 90,
                "answer": "Abuja Electric",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 6,
                "choice": null,
                "question": 3
            },
            {
                "id": 91,
                "answer": "Benin Electric",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 6,
                "choice": null,
                "question": 3
            },
            {
                "id": 92,
                "answer": "Port Harcourt Electric (PHDC)",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 6,
                "choice": null,
                "question": 3
            },
            {
                "id": 93,
                "answer": "Jumia",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 7,
                "choice": null,
                "question": 3
            },
            {
                "id": 94,
                "answer": "Konga",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 7,
                "choice": null,
                "question": 3
            },
            {
                "id": 95,
                "answer": "Jiji Ng",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 7,
                "choice": null,
                "question": 3
            },
            {
                "id": 96,
                "answer": "Payporte",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 7,
                "choice": null,
                "question": 3
            },
            {
                "id": 97,
                "answer": "Vconnect",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 7,
                "choice": null,
                "question": 3
            },
            {
                "id": 98,
                "answer": "Kara",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 7,
                "choice": null,
                "question": 3
            },
            {
                "id": 99,
                "answer": "Ajebomarket",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 7,
                "choice": null,
                "question": 3
            },
            {
                "id": 100,
                "answer": "Obiwezy",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 7,
                "choice": null,
                "question": 3
            },
            {
                "id": 101,
                "answer": "FRSC",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 8,
                "choice": null,
                "question": 3
            },
            {
                "id": 102,
                "answer": "FiRS",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 8,
                "choice": null,
                "question": 3
            },
            {
                "id": 103,
                "answer": "Nig Police (NPF)",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 8,
                "choice": null,
                "question": 3
            },
            {
                "id": 104,
                "answer": "CAC",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 8,
                "choice": null,
                "question": 3
            },
            {
                "id": 105,
                "answer": "NPA",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 8,
                "choice": null,
                "question": 3
            },
            {
                "id": 106,
                "answer": "Nig Immigration",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 8,
                "choice": null,
                "question": 3
            },
            {
                "id": 107,
                "answer": "Nigeria Customs",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 8,
                "choice": null,
                "question": 3
            },
            {
                "id": 108,
                "answer": "NIMASA",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 8,
                "choice": null,
                "question": 3
            },
            {
                "id": 109,
                "answer": "NIMC",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 8,
                "choice": null,
                "question": 3
            },
            {
                "id": 110,
                "answer": "NCC",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 8,
                "choice": null,
                "question": 3
            },
            {
                "id": 111,
                "answer": "JAMB",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 8,
                "choice": null,
                "question": 3
            },
            {
                "id": 112,
                "answer": "EFCC",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 8,
                "choice": null,
                "question": 3
            },
            {
                "id": 113,
                "answer": "ICPC",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 8,
                "choice": null,
                "question": 3
            },
            {
                "id": 114,
                "answer": "FAAN",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 8,
                "choice": null,
                "question": 3
            },
            {
                "id": 115,
                "answer": "NAFDAC",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 8,
                "choice": null,
                "question": 3
            },
            {
                "id": 116,
                "answer": "NSITF",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 8,
                "choice": null,
                "question": 3
            },
            {
                "id": 117,
                "answer": "Nigerian Railway Corp (NRC)",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 8,
                "choice": null,
                "question": 3
            },
            {
                "id": 118,
                "answer": "BON",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 8,
                "choice": null,
                "question": 3
            },
            {
                "id": 119,
                "answer": "NTA",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 8,
                "choice": null,
                "question": 3
            },
            {
                "id": 120,
                "answer": "FRCN",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 8,
                "choice": null,
                "question": 3
            },
            {
                "id": 121,
                "answer": "Eko Hotels",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 9,
                "choice": "1",
                "question": 3
            },
            {
                "id": 122,
                "answer": "Leisure Park",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 9,
                "choice": "1",
                "question": 3
            },
            {
                "id": 123,
                "answer": "Whistling Palms Badagry",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 9,
                "choice": "1",
                "question": 3
            },
            {
                "id": 124,
                "answer": "Obudu Ranch Resort",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 9,
                "choice": "1",
                "question": 3
            },
            {
                "id": 125,
                "answer": "Inagbe Resort Lagos",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 9,
                "choice": "1",
                "question": 3
            },
            {
                "id": 126,
                "answer": "Lakowe Golf Resort, Lagos",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 9,
                "choice": "1",
                "question": 3
            },
            {
                "id": 127,
                "answer": "Epe Resort & Spa, Lagos",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 9,
                "choice": "1",
                "question": 3
            },
            {
                "id": 128,
                "answer": "Mr Biggs",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 9,
                "choice": "2",
                "question": 3
            },
            {
                "id": 129,
                "answer": "Mega Chicken",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 9,
                "choice": "2",
                "question": 3
            },
            {
                "id": 130,
                "answer": "Bukka Hut",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 9,
                "choice": "2",
                "question": 3
            },
            {
                "id": 131,
                "answer": "Tantalizer's",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 9,
                "choice": "2",
                "question": 3
            },
            {
                "id": 132,
                "answer": "Sweet Sensation",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 9,
                "choice": "2",
                "question": 3
            },
            {
                "id": 133,
                "answer": "Mr Fans",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 9,
                "choice": "2",
                "question": 3
            },
            {
                "id": 464,
                "answer": "Afrikiko River Front Resort",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 4,
                "choice": null,
                "question": 3
            },
            {
                "id": 570,
                "answer": "Ikeja Electricity Distribution company (IKEDC)",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 6,
                "choice": "1",
                "question": 3
            },
            {
                "id": 571,
                "answer": "Eko Electricity Distribution Company (EKEDC)",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 6,
                "choice": "1",
                "question": 3
            },
            {
                "id": 572,
                "answer": "Enugu Electricity Distribution Company (EEDC)",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 6,
                "choice": "1",
                "question": 3
            },
            {
                "id": 573,
                "answer": "Kaduna Electricity Distribution Company (KAEDC)",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 6,
                "choice": "1",
                "question": 3
            },
            {
                "id": 574,
                "answer": "Kano Electricity Distribution Company (KEDC)",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 6,
                "choice": "1",
                "question": 3
            },
            {
                "id": 575,
                "answer": "Abuja Electricity Distribution Company (ABEDC)",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 6,
                "choice": "1",
                "question": 3
            },
            {
                "id": 576,
                "answer": "Benin Electricity Distribution Company (BEEDC)",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 6,
                "choice": "1",
                "question": 3
            },
            {
                "id": 577,
                "answer": "Port Harcourt Electricity Distribution Company (PHEDC)",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 6,
                "choice": "1",
                "question": 3
            },
            {
                "id": 578,
                "answer": "Jumia",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 7,
                "choice": "1",
                "question": 3
            },
            {
                "id": 579,
                "answer": "Konga",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 7,
                "choice": "1",
                "question": 3
            },
            {
                "id": 580,
                "answer": "Jiji",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 7,
                "choice": "1",
                "question": 3
            },
            {
                "id": 581,
                "answer": "DealDay",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 7,
                "choice": "1",
                "question": 3
            },
            {
                "id": 582,
                "answer": "Kara",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 7,
                "choice": "1",
                "question": 3
            },
            {
                "id": 583,
                "answer": "Obiweezi",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 7,
                "choice": "1",
                "question": 3
            },
            {
                "id": 584,
                "answer": "Kaymu",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 7,
                "choice": "1",
                "question": 3
            },
            {
                "id": 585,
                "answer": "SLOT",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 7,
                "choice": "1",
                "question": 3
            },
            {
                "id": 586,
                "answer": "Parktel",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 7,
                "choice": "1",
                "question": 3
            },
            {
                "id": 587,
                "answer": "Nigeria Police Force (NPF)",
                "answer_title": "Government Agencies",
                "answer_type": "CHECKBOX",
                "sector_id": 8,
                "choice": "1",
                "question": 3
            },
            {
                "id": 588,
                "answer": "Nigeria Customs",
                "answer_title": "Government Agencies",
                "answer_type": "CHECKBOX",
                "sector_id": 8,
                "choice": "1",
                "question": 3
            },
            {
                "id": 589,
                "answer": "Nigeria Immigration services (NIS)",
                "answer_title": "Government Agencies",
                "answer_type": "CHECKBOX",
                "sector_id": 8,
                "choice": "1",
                "question": 3
            },
            {
                "id": 590,
                "answer": "Nigeria Ports Authority (NPA)",
                "answer_title": "Government Agencies",
                "answer_type": "CHECKBOX",
                "sector_id": 8,
                "choice": "1",
                "question": 3
            },
            {
                "id": 591,
                "answer": "Fed Road Safety Comm (FRSC)",
                "answer_title": "Government Agencies",
                "answer_type": "CHECKBOX",
                "sector_id": 8,
                "choice": "1",
                "question": 3
            },
            {
                "id": 592,
                "answer": "Federal Inland Revenue (FIRS)",
                "answer_title": "Government Agencies",
                "answer_type": "CHECKBOX",
                "sector_id": 8,
                "choice": "1",
                "question": 3
            },
            {
                "id": 593,
                "answer": "Coporate Affairs Comm (CAC)",
                "answer_title": "Government Agencies",
                "answer_type": "CHECKBOX",
                "sector_id": 8,
                "choice": "1",
                "question": 3
            },
            {
                "id": 594,
                "answer": "EFCC",
                "answer_title": "Government Agencies",
                "answer_type": "CHECKBOX",
                "sector_id": 8,
                "choice": "1",
                "question": 3
            },
            {
                "id": 595,
                "answer": "NAFDAC",
                "answer_title": "Government Agencies",
                "answer_type": "CHECKBOX",
                "sector_id": 8,
                "choice": "1",
                "question": 3
            },
            {
                "id": 596,
                "answer": "NIMASA",
                "answer_title": "Government Agencies",
                "answer_type": "CHECKBOX",
                "sector_id": 8,
                "choice": "1",
                "question": 3
            },
            {
                "id": 597,
                "answer": "Nigeria High Commission, London- UK",
                "answer_title": "Nigeria Missions/Embassies",
                "answer_type": "CHECKBOX",
                "sector_id": 8,
                "choice": "1",
                "question": 3
            },
            {
                "id": 598,
                "answer": "Nigeria High Commission - South Africa",
                "answer_title": "Nigeria Missions/Embassies",
                "answer_type": "CHECKBOX",
                "sector_id": 8,
                "choice": "1",
                "question": 3
            },
            {
                "id": 599,
                "answer": "Nigeria High Commission - Ghana",
                "answer_title": "Nigeria Missions/Embassies",
                "answer_type": "CHECKBOX",
                "sector_id": 8,
                "choice": "1",
                "question": 3
            },
            {
                "id": 600,
                "answer": "Nigeria High Commission - Canada",
                "answer_title": "Nigeria Missions/Embassies",
                "answer_type": "CHECKBOX",
                "sector_id": 8,
                "choice": "1",
                "question": 3
            },
            {
                "id": 601,
                "answer": "Nigeria embassy - Abidjan",
                "answer_title": "Nigeria Missions/Embassies",
                "answer_type": "CHECKBOX",
                "sector_id": 8,
                "choice": "1",
                "question": 3
            },
            {
                "id": 602,
                "answer": "Nigeria Consulate, Atlanta - USA",
                "answer_title": "Nigeria Missions/Embassies",
                "answer_type": "CHECKBOX",
                "sector_id": 8,
                "choice": "1",
                "question": 3
            },
            {
                "id": 603,
                "answer": "Nigeria consulate, New York - USA",
                "answer_title": "Nigeria Missions/Embassies",
                "answer_type": "CHECKBOX",
                "sector_id": 8,
                "choice": "1",
                "question": 3
            },
            {
                "id": 604,
                "answer": "Nigeria embassy, Beijing China",
                "answer_title": "Nigeria Missions/Embassies",
                "answer_type": "CHECKBOX",
                "sector_id": 8,
                "choice": "1",
                "question": 3
            },
            {
                "id": 605,
                "answer": "Nigeria Consulate, Guangzhou, China",
                "answer_title": "Nigeria Missions/Embassies",
                "answer_type": "CHECKBOX",
                "sector_id": 8,
                "choice": "1",
                "question": 3
            },
            {
                "id": 606,
                "answer": "Nigeria High commission, New Delhi - India",
                "answer_title": "Nigeria Missions/Embassies",
                "answer_type": "CHECKBOX",
                "sector_id": 8,
                "choice": "1",
                "question": 3
            },
            {
                "id": 607,
                "answer": "Hygeia HMO",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 3,
                "choice": "2",
                "question": 3
            },
            {
                "id": 608,
                "answer": "Redcare HMO",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 3,
                "choice": "2",
                "question": 3
            },
            {
                "id": 609,
                "answer": "IIHMS HMO",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 3,
                "choice": "2",
                "question": 3
            },
            {
                "id": 610,
                "answer": "NOVO HMO",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 3,
                "choice": "2",
                "question": 3
            },
            {
                "id": 611,
                "answer": "AIICO HMO",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 3,
                "choice": "2",
                "question": 3
            },
            {
                "id": 617,
                "answer": "AIICO Insurance",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 3,
                "choice": "1",
                "question": 3
            },
            {
                "id": 618,
                "answer": "Cornerstone Insurance",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 3,
                "choice": "1",
                "question": 3
            },
            {
                "id": 619,
                "answer": "LASACO Assurance",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 3,
                "choice": "1",
                "question": 3
            },
            {
                "id": 620,
                "answer": "Leadway Assurance",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 3,
                "choice": "1",
                "question": 3
            },
            {
                "id": 621,
                "answer": "NEM Insurance",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 3,
                "choice": "1",
                "question": 3
            },
            {
                "id": 629,
                "answer": "University of Port Harcourt Teach, Hospital (UPTH)",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 4,
                "choice": "1",
                "question": 3
            },
            {
                "id": 640,
                "answer": "Adron Homes",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 632,
                "choice": "1",
                "question": 3
            },
            {
                "id": 641,
                "answer": "Lekki Homes & Gardens",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 632,
                "choice": "1",
                "question": 3
            },
            {
                "id": 642,
                "answer": "RealtyPoint",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 632,
                "choice": "1",
                "question": 3
            },
            {
                "id": 643,
                "answer": "Sujimoto Group",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 632,
                "choice": "1",
                "question": 3
            },
            {
                "id": 644,
                "answer": "RevolutionPlus Properties",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 632,
                "choice": "1",
                "question": 3
            },
            {
                "id": 645,
                "answer": "Primerose Properties",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 632,
                "choice": "1",
                "question": 3
            },
            {
                "id": 646,
                "answer": "Unilag (Lagos)",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 633,
                "choice": "1",
                "question": 3
            },
            {
                "id": 647,
                "answer": "Covenant University",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 633,
                "choice": "2",
                "question": 3
            },
            {
                "id": 649,
                "answer": "ABU - Zaria",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 633,
                "choice": "1",
                "question": 3
            },
            {
                "id": 650,
                "answer": "UNN-Nsukka",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 633,
                "choice": "1",
                "question": 3
            },
            {
                "id": 651,
                "answer": "UI-Ibadan",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 633,
                "choice": "1",
                "question": 3
            },
            {
                "id": 652,
                "answer": "OAU- Ile Ife",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 633,
                "choice": "1",
                "question": 3
            },
            {
                "id": 653,
                "answer": "Unijos",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 633,
                "choice": "1",
                "question": 3
            },
            {
                "id": 654,
                "answer": "LASU",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 633,
                "choice": "1",
                "question": 3
            },
            {
                "id": 655,
                "answer": "BUK -KANO",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 633,
                "choice": "1",
                "question": 3
            },
            {
                "id": 656,
                "answer": "Yabatech",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 633,
                "choice": "1",
                "question": 3
            },
            {
                "id": 657,
                "answer": "Babcock University",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 633,
                "choice": "2",
                "question": 3
            },
            {
                "id": 658,
                "answer": "Afe Babalola University",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 633,
                "choice": "2",
                "question": 3
            },
            {
                "id": 659,
                "answer": "Madonna University",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 633,
                "choice": "2",
                "question": 3
            },
            {
                "id": 660,
                "answer": "Bowen University",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 633,
                "choice": "2",
                "question": 3
            },
            {
                "id": 661,
                "answer": "American University of Nigeria",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 633,
                "choice": "2",
                "question": 3
            },
            {
                "id": 662,
                "answer": "Bet9ja",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 634,
                "choice": "1",
                "question": 3
            },
            {
                "id": 663,
                "answer": "SportyBet",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 634,
                "choice": "1",
                "question": 3
            },
            {
                "id": 664,
                "answer": "1XBet",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 634,
                "choice": "1",
                "question": 3
            },
            {
                "id": 665,
                "answer": "WGB",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 634,
                "choice": "1",
                "question": 3
            },
            {
                "id": 666,
                "answer": "BetWay",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 634,
                "choice": "1",
                "question": 3
            },
            {
                "id": 667,
                "answer": "BetKing",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 634,
                "choice": "1",
                "question": 3
            },
            {
                "id": 668,
                "answer": "NairaBet",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 634,
                "choice": "1",
                "question": 3
            },
            {
                "id": 669,
                "answer": "MerryBet",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 634,
                "choice": "1",
                "question": 3
            }
        ]
    },
    {
        "id": 4,
        "question": "Out of the SELECTED_COMPANIES above, concerning their services, which of them have you interacted/had dealings with MOST OFTEN. If the COMPANY_TYPE is not listed, please type it in the space provided for Others.",
        "response_type": "Radio",
        "answers": [
            {
                "id": 172,
                "answer": "Access Bank",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": 1,
                "choice": "1",
                "question": 4
            },
            {
                "id": 173,
                "answer": "GTBank",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 1,
                "choice": "1",
                "question": 4
            },
            {
                "id": 174,
                "answer": "Zenith Bank",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 1,
                "choice": "1",
                "question": 4
            },
            {
                "id": 175,
                "answer": "Fidelity Bank",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 1,
                "choice": "1",
                "question": 4
            },
            {
                "id": 176,
                "answer": "Union Bank",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 1,
                "choice": "1",
                "question": 4
            },
            {
                "id": 177,
                "answer": "Keystone Bank",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 1,
                "choice": "1",
                "question": 4
            },
            {
                "id": 178,
                "answer": "Polaris Bank",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 1,
                "choice": "1",
                "question": 4
            },
            {
                "id": 179,
                "answer": "First Bank",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 1,
                "choice": "1",
                "question": 4
            },
            {
                "id": 180,
                "answer": "Wema Bank",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 1,
                "choice": "1",
                "question": 4
            },
            {
                "id": 181,
                "answer": "Sterling Bank",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 1,
                "choice": "1",
                "question": 4
            },
            {
                "id": 182,
                "answer": "Paystack",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 1,
                "choice": "2",
                "question": 4
            },
            {
                "id": 183,
                "answer": "Paga",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 1,
                "choice": "2",
                "question": 4
            },
            {
                "id": 184,
                "answer": "Flutterwave",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 1,
                "choice": "2",
                "question": 4
            },
            {
                "id": 185,
                "answer": "Carbon",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 1,
                "choice": "2",
                "question": 4
            },
            {
                "id": 186,
                "answer": "Nomba",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 1,
                "choice": "2",
                "question": 4
            },
            {
                "id": 187,
                "answer": "Globalcom",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 2,
                "choice": "1",
                "question": 4
            },
            {
                "id": 188,
                "answer": "MTN",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 2,
                "choice": "1",
                "question": 4
            },
            {
                "id": 189,
                "answer": "Airtel",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 2,
                "choice": "1",
                "question": 4
            },
            {
                "id": 190,
                "answer": "9mobile",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 2,
                "choice": "1",
                "question": 4
            },
            {
                "id": 191,
                "answer": "IGI",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 3,
                "choice": "1",
                "question": 4
            },
            {
                "id": 192,
                "answer": "Axa Mansard",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 3,
                "choice": "1",
                "question": 4
            },
            {
                "id": 193,
                "answer": "Heirs Insurance",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 3,
                "choice": "1",
                "question": 4
            },
            {
                "id": 194,
                "answer": "TANGERINE LIFE",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 3,
                "choice": "1",
                "question": 4
            },
            {
                "id": 195,
                "answer": "Anchor HMO",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 3,
                "choice": "2",
                "question": 4
            },
            {
                "id": 196,
                "answer": "Reliance HMO",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 3,
                "choice": "2",
                "question": 4
            },
            {
                "id": 197,
                "answer": "Avon HMO",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 3,
                "choice": "2",
                "question": 4
            },
            {
                "id": 198,
                "answer": "AXA HMO",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 3,
                "choice": "2",
                "question": 4
            },
            {
                "id": 199,
                "answer": "LUTH - Idi Araba",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 4,
                "choice": "1",
                "question": 4
            },
            {
                "id": 200,
                "answer": "UNTH - Enugu",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 4,
                "choice": "1",
                "question": 4
            },
            {
                "id": 201,
                "answer": "UITH - Ibadan",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 4,
                "choice": "1",
                "question": 4
            },
            {
                "id": 202,
                "answer": "LASUTH - Ikeja",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 4,
                "choice": "1",
                "question": 4
            },
            {
                "id": 203,
                "answer": "ABUTH - Bauchi",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 4,
                "choice": "1",
                "question": 4
            },
            {
                "id": 204,
                "answer": "ABUTH - Kano",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 4,
                "choice": "1",
                "question": 4
            },
            {
                "id": 205,
                "answer": "General Hospital - Gbagada",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 4,
                "choice": "1",
                "question": 4
            },
            {
                "id": 206,
                "answer": "UCTH - Calabar",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 4,
                "choice": "1",
                "question": 4
            },
            {
                "id": 207,
                "answer": "Military Hospital - Yaba",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 4,
                "choice": "1",
                "question": 4
            },
            {
                "id": 208,
                "answer": "UniAbuja Teaching Hospital",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 4,
                "choice": "1",
                "question": 4
            },
            {
                "id": 209,
                "answer": "FMC Owerri",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 4,
                "choice": "1",
                "question": 4
            },
            {
                "id": 210,
                "answer": "FMC Umuahia",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 4,
                "choice": "1",
                "question": 4
            },
            {
                "id": 211,
                "answer": "Uniport Tech Hospital",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 4,
                "choice": "1",
                "question": 4
            },
            {
                "id": 212,
                "answer": "EKO Hospital",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 4,
                "choice": "2",
                "question": 4
            },
            {
                "id": 213,
                "answer": "Lagoon Hospital",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 4,
                "choice": "2",
                "question": 4
            },
            {
                "id": 214,
                "answer": "Surjen Hospital",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 4,
                "choice": "2",
                "question": 4
            },
            {
                "id": 215,
                "answer": "Duchess Hospital",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 4,
                "choice": "2",
                "question": 4
            },
            {
                "id": 216,
                "answer": "Reddington Hospital",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 4,
                "choice": "2",
                "question": 4
            },
            {
                "id": 217,
                "answer": "Airpeace",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 5,
                "choice": "1",
                "question": 4
            },
            {
                "id": 218,
                "answer": "Ibom Air",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 5,
                "choice": "1",
                "question": 4
            },
            {
                "id": 219,
                "answer": "Arik Air",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 5,
                "choice": "1",
                "question": 4
            },
            {
                "id": 220,
                "answer": "Dana Air",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 5,
                "choice": "1",
                "question": 4
            },
            {
                "id": 221,
                "answer": "ABC Transports",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 5,
                "choice": "2",
                "question": 4
            },
            {
                "id": 222,
                "answer": "God is Good",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 5,
                "choice": "2",
                "question": 4
            },
            {
                "id": 223,
                "answer": "The Young Shall Grow",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 5,
                "choice": "2",
                "question": 4
            },
            {
                "id": 224,
                "answer": "Libra Motors",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 5,
                "choice": "2",
                "question": 4
            },
            {
                "id": 225,
                "answer": "GUO Transport",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 5,
                "choice": "2",
                "question": 4
            },
            {
                "id": 226,
                "answer": "LAMATA",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 5,
                "choice": "3",
                "question": 4
            },
            {
                "id": 227,
                "answer": "BRT",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 5,
                "choice": "3",
                "question": 4
            },
            {
                "id": 228,
                "answer": "Bolt",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 5,
                "choice": "3",
                "question": 4
            },
            {
                "id": 229,
                "answer": "Uber",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 5,
                "choice": "3",
                "question": 4
            },
            {
                "id": 230,
                "answer": "InDrive",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 5,
                "choice": "3",
                "question": 4
            },
            {
                "id": 231,
                "answer": "Ikeja Electric (IKDC)",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 6,
                "choice": null,
                "question": 4
            },
            {
                "id": 232,
                "answer": "EKO Electric (EKDC)",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 6,
                "choice": null,
                "question": 4
            },
            {
                "id": 233,
                "answer": "Enugu Electric",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 6,
                "choice": null,
                "question": 4
            },
            {
                "id": 234,
                "answer": "Abuja Electric",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 6,
                "choice": null,
                "question": 4
            },
            {
                "id": 235,
                "answer": "Benin Electric",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 6,
                "choice": null,
                "question": 4
            },
            {
                "id": 236,
                "answer": "Port Harcourt Electric (PHDC)",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 6,
                "choice": null,
                "question": 4
            },
            {
                "id": 237,
                "answer": "Jumia",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 7,
                "choice": null,
                "question": 4
            },
            {
                "id": 238,
                "answer": "Konga",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 7,
                "choice": null,
                "question": 4
            },
            {
                "id": 239,
                "answer": "Jiji Ng",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 7,
                "choice": null,
                "question": 4
            },
            {
                "id": 240,
                "answer": "Payporte",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 7,
                "choice": null,
                "question": 4
            },
            {
                "id": 241,
                "answer": "Vconnect",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 7,
                "choice": null,
                "question": 4
            },
            {
                "id": 242,
                "answer": "Kara",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 7,
                "choice": null,
                "question": 4
            },
            {
                "id": 243,
                "answer": "Ajebomarket",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 7,
                "choice": null,
                "question": 4
            },
            {
                "id": 244,
                "answer": "Obiwezy",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 7,
                "choice": null,
                "question": 4
            },
            {
                "id": 245,
                "answer": "FRSC",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 8,
                "choice": null,
                "question": 4
            },
            {
                "id": 246,
                "answer": "FiRS",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 8,
                "choice": null,
                "question": 4
            },
            {
                "id": 247,
                "answer": "Nig Police (NPF)",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 8,
                "choice": null,
                "question": 4
            },
            {
                "id": 248,
                "answer": "CAC",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 8,
                "choice": null,
                "question": 4
            },
            {
                "id": 249,
                "answer": "NPA",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 8,
                "choice": null,
                "question": 4
            },
            {
                "id": 250,
                "answer": "Nig Immigration",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 8,
                "choice": null,
                "question": 4
            },
            {
                "id": 251,
                "answer": "Nigeria Customs",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 8,
                "choice": null,
                "question": 4
            },
            {
                "id": 252,
                "answer": "NIMASA",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 8,
                "choice": null,
                "question": 4
            },
            {
                "id": 253,
                "answer": "NIMC",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 8,
                "choice": null,
                "question": 4
            },
            {
                "id": 254,
                "answer": "NCC",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 8,
                "choice": null,
                "question": 4
            },
            {
                "id": 255,
                "answer": "JAMB",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 8,
                "choice": null,
                "question": 4
            },
            {
                "id": 256,
                "answer": "EFCC",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 8,
                "choice": null,
                "question": 4
            },
            {
                "id": 257,
                "answer": "ICPC",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 8,
                "choice": null,
                "question": 4
            },
            {
                "id": 258,
                "answer": "FAAN",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 8,
                "choice": null,
                "question": 4
            },
            {
                "id": 259,
                "answer": "NAFDAC",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 8,
                "choice": null,
                "question": 4
            },
            {
                "id": 260,
                "answer": "NSITF",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 8,
                "choice": null,
                "question": 4
            },
            {
                "id": 261,
                "answer": "Nigerian Railway Corp (NRC)",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 8,
                "choice": null,
                "question": 4
            },
            {
                "id": 262,
                "answer": "BON",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 8,
                "choice": null,
                "question": 4
            },
            {
                "id": 263,
                "answer": "NTA",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 8,
                "choice": null,
                "question": 4
            },
            {
                "id": 264,
                "answer": "FRCN",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 8,
                "choice": null,
                "question": 4
            },
            {
                "id": 265,
                "answer": "Eko Hotels",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 9,
                "choice": "1",
                "question": 4
            },
            {
                "id": 266,
                "answer": "Leisure Park",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 9,
                "choice": "1",
                "question": 4
            },
            {
                "id": 267,
                "answer": "Whistling Palms Badagry",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 9,
                "choice": "1",
                "question": 4
            },
            {
                "id": 268,
                "answer": "Obudu Ranch Resort",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 9,
                "choice": "1",
                "question": 4
            },
            {
                "id": 269,
                "answer": "Inagbe Resort Lagos",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 9,
                "choice": "1",
                "question": 4
            },
            {
                "id": 270,
                "answer": "Lakowe Golf Resort, Lagos",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 9,
                "choice": "1",
                "question": 4
            },
            {
                "id": 271,
                "answer": "Epe Resort & Spa, Lagos",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 9,
                "choice": "1",
                "question": 4
            },
            {
                "id": 272,
                "answer": "Mr Biggs",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 9,
                "choice": "2",
                "question": 4
            },
            {
                "id": 273,
                "answer": "Mega Chicken",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 9,
                "choice": "2",
                "question": 4
            },
            {
                "id": 274,
                "answer": "Bukka Hut",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 9,
                "choice": "2",
                "question": 4
            },
            {
                "id": 275,
                "answer": "Tantalizer's",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 9,
                "choice": "2",
                "question": 4
            },
            {
                "id": 276,
                "answer": "Sweet Sensation",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 9,
                "choice": "2",
                "question": 4
            },
            {
                "id": 277,
                "answer": "Mr Fans",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 9,
                "choice": "2",
                "question": 4
            },
            {
                "id": 278,
                "answer": "Smile",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 2,
                "choice": "2",
                "question": 4
            },
            {
                "id": 279,
                "answer": "ipnx",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 2,
                "choice": "2",
                "question": 4
            },
            {
                "id": 280,
                "answer": "Spectranet",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 2,
                "choice": "2",
                "question": 4
            },
            {
                "id": 281,
                "answer": "Tizeti",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 2,
                "choice": "2",
                "question": 4
            },
            {
                "id": 282,
                "answer": "Globalcom",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 2,
                "choice": "2",
                "question": 4
            },
            {
                "id": 283,
                "answer": "MTN",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 2,
                "choice": "2",
                "question": 4
            },
            {
                "id": 284,
                "answer": "Airtel",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 2,
                "choice": "2",
                "question": 4
            },
            {
                "id": 285,
                "answer": "9mobile",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 2,
                "choice": "2",
                "question": 4
            },
            {
                "id": 465,
                "answer": "Afrikiko River Front Resort",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 4,
                "choice": null,
                "question": 4
            },
            {
                "id": 612,
                "answer": "Hygeia HMO",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 3,
                "choice": "2",
                "question": 4
            },
            {
                "id": 613,
                "answer": "Redcare HMO",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 3,
                "choice": "2",
                "question": 4
            },
            {
                "id": 614,
                "answer": "IIHMS HMO",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 3,
                "choice": "2",
                "question": 4
            },
            {
                "id": 615,
                "answer": "NOVO HMO",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 3,
                "choice": "2",
                "question": 4
            },
            {
                "id": 616,
                "answer": "AIICO HMO",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 3,
                "choice": "2",
                "question": 4
            },
            {
                "id": 622,
                "answer": "AIICO Insurance",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 3,
                "choice": "1",
                "question": 4
            },
            {
                "id": 623,
                "answer": "Cornerstone Insurance",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 3,
                "choice": "1",
                "question": 4
            },
            {
                "id": 624,
                "answer": "LASACO Assurance",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 3,
                "choice": "1",
                "question": 4
            },
            {
                "id": 625,
                "answer": "Leadway Assurance",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 3,
                "choice": "1",
                "question": 4
            },
            {
                "id": 626,
                "answer": "NEM Insurance",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 3,
                "choice": "1",
                "question": 4
            },
            {
                "id": 630,
                "answer": "University of Port Harcourt Teach, Hospital (UPTH)",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 4,
                "choice": "1",
                "question": 4
            }
        ]
    },
    {
        "id": 5,
        "question": "ONE (1) RESPONSE PER ROW. Please select a rating that best describes your extent of satisfaction with your experience with SELECTED_COMPANY in terms of the following, where 1 means totally dissatisfied, and 7 means totally satisfied.",
        "response_type": "MultiRadio",
        "answers": [
            {
                "id": 325,
                "answer": "Trust",
                "answer_title": "{'begin': 'Totally dissatisfied', 'end': 'Totally satisfied'}",
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 5
            },
            {
                "id": 326,
                "answer": "Branches, Branding & Outlook",
                "answer_title": "{'begin': 'Totally dissatisfied', 'end': 'Totally satisfied'}",
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 5
            },
            {
                "id": 327,
                "answer": "Customer Focused Innovations",
                "answer_title": "{'begin': 'Totally dissatisfied', 'end': 'Totally satisfied'}",
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 5
            },
            {
                "id": 328,
                "answer": "Ease Of Transaction/ Doing Business",
                "answer_title": "{'begin': 'Totally dissatisfied', 'end': 'Totally satisfied'}",
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 5
            },
            {
                "id": 329,
                "answer": "Staff Engagement/ Competence",
                "answer_title": "{'begin': 'Totally dissatisfied', 'end': 'Totally satisfied'}",
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 5
            },
            {
                "id": 330,
                "answer": "Complaint Resolution",
                "answer_title": "{'begin': 'Totally dissatisfied', 'end': 'Totally satisfied'}",
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 5
            },
            {
                "id": 331,
                "answer": "Process & Procedures",
                "answer_title": "{'begin': 'Totally dissatisfied', 'end': 'Totally satisfied'}",
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 5
            },
            {
                "id": 332,
                "answer": "Professionalism",
                "answer_title": "{'begin': 'Totally dissatisfied', 'end': 'Totally satisfied'}",
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 5
            }
        ]
    },
    {
        "id": 6,
        "question": "ONE (1) RESPONSE PER COLUMN. Please arrange the eight (8) customer service indicators in order of their importance to you, where 1 is Least Important and 8 is Most Important.",
        "response_type": "MultiCheck",
        "answers": [
            {
                "id": 335,
                "answer": "Trust",
                "answer_title": "{'begin': 'Totally dissatisfied', 'end': 'Totally satisfied'}",
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 6
            },
            {
                "id": 336,
                "answer": "Branches, Branding & Outlook",
                "answer_title": "{'begin': 'Totally dissatisfied', 'end': 'Totally satisfied'}",
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 6
            },
            {
                "id": 337,
                "answer": "Customer Focused Innovations",
                "answer_title": "{'begin': 'Totally dissatisfied', 'end': 'Totally satisfied'}",
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 6
            },
            {
                "id": 338,
                "answer": "Ease Of Transaction/ Doing Business",
                "answer_title": "{'begin': 'Totally dissatisfied', 'end': 'Totally satisfied'}",
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 6
            },
            {
                "id": 339,
                "answer": "Staff Engagement/ Competence",
                "answer_title": "{'begin': 'Totally dissatisfied', 'end': 'Totally satisfied'}",
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 6
            },
            {
                "id": 340,
                "answer": "Complaint Resolution",
                "answer_title": "{'begin': 'Totally dissatisfied', 'end': 'Totally satisfied'}",
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 6
            },
            {
                "id": 341,
                "answer": "Process & Procedures",
                "answer_title": "{'begin': 'Totally dissatisfied', 'end': 'Totally satisfied'}",
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 6
            },
            {
                "id": 342,
                "answer": "Professionalism",
                "answer_title": "{'begin': 'Totally dissatisfied', 'end': 'Totally satisfied'}",
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 6
            }
        ]
    },
    {
        "id": 7,
        "question": "Overall, what are your impressions on customer service in Nigeria's SECTOR sub-sector?",
        "response_type": "Text",
        "answers": []
    },
    {
        "id": 8,
        "question": "As a customer of SELECTED_COMPANY do you prefer excellent service, even if it costs more, or a lowest cost, no frills service?",
        "response_type": "RadioInline",
        "answers": [
            {
                "id": 345,
                "answer": "1",
                "answer_title": "{'begin': 'I prefer a no frills, lowest price service', 'end': 'I prefer excellent service, even if it costs more'}",
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 8
            },
            {
                "id": 346,
                "answer": "2",
                "answer_title": "{'begin': 'I prefer a no frills, lowest price service', 'end': 'I prefer excellent service, even if it costs more'}",
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 8
            },
            {
                "id": 347,
                "answer": "3",
                "answer_title": "{'begin': 'I prefer a no frills, lowest price service', 'end': 'I prefer excellent service, even if it costs more'}",
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 8
            },
            {
                "id": 348,
                "answer": "4",
                "answer_title": "{'begin': 'I prefer a no frills, lowest price service', 'end': 'I prefer excellent service, even if it costs more'}",
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 8
            },
            {
                "id": 349,
                "answer": "5",
                "answer_title": "{'begin': 'I prefer a no frills, lowest price service', 'end': 'I prefer excellent service, even if it costs more'}",
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 8
            },
            {
                "id": 350,
                "answer": "6",
                "answer_title": "{'begin': 'I prefer a no frills, lowest price service', 'end': 'I prefer excellent service, even if it costs more'}",
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 8
            },
            {
                "id": 351,
                "answer": "7",
                "answer_title": "{'begin': 'I prefer a no frills, lowest price service', 'end': 'I prefer excellent service, even if it costs more'}",
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 8
            }
        ]
    },
    {
        "id": 9,
        "question": "Overall, how satisfied or dissatisfied are you with the customer service of SELECTED_COMPANY?",
        "response_type": "RadioInline",
        "answers": [
            {
                "id": 352,
                "answer": "1",
                "answer_title": "{'begin': 'Extremely dissatisfied', 'end': 'Extremely satisfied'}",
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 9
            },
            {
                "id": 353,
                "answer": "2",
                "answer_title": "{'begin': 'Extremely dissatisfied', 'end': 'Extremely satisfied'}",
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 9
            },
            {
                "id": 354,
                "answer": "3",
                "answer_title": "{'begin': 'Extremely dissatisfied', 'end': 'Extremely satisfied'}",
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 9
            },
            {
                "id": 355,
                "answer": "4",
                "answer_title": "{'begin': 'Extremely dissatisfied', 'end': 'Extremely satisfied'}",
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 9
            },
            {
                "id": 356,
                "answer": "5",
                "answer_title": "{'begin': 'Extremely dissatisfied', 'end': 'Extremely satisfied'}",
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 9
            },
            {
                "id": 357,
                "answer": "6",
                "answer_title": "{'begin': 'Extremely dissatisfied', 'end': 'Extremely satisfied'}",
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 9
            },
            {
                "id": 358,
                "answer": "7",
                "answer_title": "{'begin': 'Extremely dissatisfied', 'end': 'Extremely satisfied'}",
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 9
            }
        ]
    },
    {
        "id": 10,
        "question": "How likely are you to recommend SELECTED_COMPANY to a relative, friend or coworker in the future. We shall use a 10 point scale where 0 means very unlikely and 10 very likely.",
        "response_type": "RadioInline",
        "answers": [
            {
                "id": 359,
                "answer": "0",
                "answer_title": "{'begin': 'Very unlikely', 'end': 'Very likely'}",
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 10
            },
            {
                "id": 360,
                "answer": "1",
                "answer_title": "{'begin': 'Very unlikely', 'end': 'Very likely'}",
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 10
            },
            {
                "id": 361,
                "answer": "2",
                "answer_title": "{'begin': 'Very unlikely', 'end': 'Very likely'}",
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 10
            },
            {
                "id": 362,
                "answer": "3",
                "answer_title": "{'begin': 'Very unlikely', 'end': 'Very likely'}",
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 10
            },
            {
                "id": 363,
                "answer": "4",
                "answer_title": "{'begin': 'Very unlikely', 'end': 'Very likely'}",
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 10
            },
            {
                "id": 364,
                "answer": "5",
                "answer_title": "{'begin': 'Very unlikely', 'end': 'Very likely'}",
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 10
            },
            {
                "id": 365,
                "answer": "6",
                "answer_title": "{'begin': 'Very unlikely', 'end': 'Very likely'}",
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 10
            },
            {
                "id": 366,
                "answer": "7",
                "answer_title": "{'begin': 'Very unlikely', 'end': 'Very likely'}",
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 10
            },
            {
                "id": 367,
                "answer": "8",
                "answer_title": "{'begin': 'Very unlikely', 'end': 'Very likely'}",
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 10
            },
            {
                "id": 368,
                "answer": "9",
                "answer_title": "{'begin': 'Very unlikely', 'end': 'Very likely'}",
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 10
            },
            {
                "id": 369,
                "answer": "10",
                "answer_title": "{'begin': 'Very unlikely', 'end': 'Very likely'}",
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 10
            }
        ]
    },
    {
        "id": 11,
        "question": "What will be a major reason not to patronize hospitality centres in Nigeria?",
        "response_type": "Radio",
        "answers": [
            {
                "id": 370,
                "answer": "Quite expensive as compared to same facility outside Nigeria",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": null,
                "choice": null,
                "question": 11
            },
            {
                "id": 371,
                "answer": "Not much exciting events/programs on offer",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": null,
                "choice": null,
                "question": 11
            },
            {
                "id": 372,
                "answer": "No adequate health & safety facilities at venue",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": null,
                "choice": null,
                "question": 11
            },
            {
                "id": 373,
                "answer": "Security concern for people and their valuables.",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": null,
                "choice": null,
                "question": 11
            }
        ]
    },
    {
        "id": 12,
        "question": "What are your concerns when visiting bars, lounges, eateries?",
        "response_type": "Checkbox",
        "answers": [
            {
                "id": 379,
                "answer": "Quality of consumable compared to it price not commensurate",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": null,
                "choice": null,
                "question": 12
            },
            {
                "id": 380,
                "answer": "Not enough sit in and parking spaces",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": null,
                "choice": null,
                "question": 12
            },
            {
                "id": 381,
                "answer": "Unethical and uncanny request for tips by staff",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": null,
                "choice": null,
                "question": 12
            },
            {
                "id": 508,
                "answer": "Class classification / gender bias",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": null,
                "choice": null,
                "question": 12
            }
        ]
    },
    {
        "id": 13,
        "question": "Through which of the following means do you normally interact with SELECTED_COMPANY?",
        "response_type": "Dropdown",
        "answers": [
            {
                "id": 382,
                "answer": "Digital Channels",
                "answer_title": null,
                "answer_type": "SELECT",
                "sector_id": null,
                "choice": "DIGITAL",
                "question": 13
            },
            {
                "id": 383,
                "answer": "Traditional Channels",
                "answer_title": null,
                "answer_type": "SELECT",
                "sector_id": null,
                "choice": "TRADITIONAL",
                "question": 13
            },
            {
                "id": 384,
                "answer": "Both Digital and Traditional Channels",
                "answer_title": null,
                "answer_type": "SELECT",
                "sector_id": null,
                "choice": "BOTH",
                "question": 13
            }
        ]
    },
    {
        "id": 14,
        "question": "Through which of the following specific means do you normally interact with SELECTED_COMPANY?",
        "response_type": "Checkbox",
        "answers": [
            {
                "id": 385,
                "answer": "Mobile App",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": null,
                "choice": "DIGITAL",
                "question": 14
            },
            {
                "id": 386,
                "answer": "Webchat",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": null,
                "choice": "DIGITAL",
                "question": 14
            },
            {
                "id": 387,
                "answer": "Email",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": null,
                "choice": "DIGITAL",
                "question": 14
            },
            {
                "id": 388,
                "answer": "Text/Over the Phone",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": null,
                "choice": "DIGITAL",
                "question": 14
            },
            {
                "id": 389,
                "answer": "Website",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": null,
                "choice": "DIGITAL",
                "question": 14
            },
            {
                "id": 390,
                "answer": "Social Media",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": null,
                "choice": "DIGITAL",
                "question": 14
            },
            {
                "id": 391,
                "answer": "In Writing",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": null,
                "choice": "TRADITIONAL",
                "question": 14
            },
            {
                "id": 392,
                "answer": "In Person",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": null,
                "choice": "TRADITIONAL",
                "question": 14
            },
            {
                "id": 393,
                "answer": "Mobile App",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": null,
                "choice": "BOTH",
                "question": 14
            },
            {
                "id": 394,
                "answer": "Webchat",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": null,
                "choice": "BOTH",
                "question": 14
            },
            {
                "id": 395,
                "answer": "Email",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": null,
                "choice": "BOTH",
                "question": 14
            },
            {
                "id": 396,
                "answer": "Text/Over the Phone",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": null,
                "choice": "BOTH",
                "question": 14
            },
            {
                "id": 397,
                "answer": "Website",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": null,
                "choice": "BOTH",
                "question": 14
            },
            {
                "id": 398,
                "answer": "Social Media",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": null,
                "choice": "BOTH",
                "question": 14
            },
            {
                "id": 399,
                "answer": "In Writing",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": null,
                "choice": "BOTH",
                "question": 14
            },
            {
                "id": 400,
                "answer": "In Person",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": null,
                "choice": "BOTH",
                "question": 14
            }
        ]
    },
    {
        "id": 15,
        "question": "What is your gender?",
        "response_type": "Radio",
        "answers": [
            {
                "id": 401,
                "answer": "Male",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 15
            },
            {
                "id": 402,
                "answer": "Female",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 15
            }
        ]
    },
    {
        "id": 17,
        "question": "Which of these brackets do you fall?",
        "response_type": "Radio",
        "answers": [
            {
                "id": 403,
                "answer": "Below 18",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 17
            },
            {
                "id": 404,
                "answer": "18 - 24",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 17
            },
            {
                "id": 405,
                "answer": "25 - 29",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 17
            },
            {
                "id": 406,
                "answer": "30 - 34",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 17
            },
            {
                "id": 407,
                "answer": "35 - 39",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 17
            },
            {
                "id": 408,
                "answer": "40 - 49",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 17
            },
            {
                "id": 409,
                "answer": "50 - 59",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 17
            },
            {
                "id": 410,
                "answer": "60+",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 17
            }
        ]
    },
    {
        "id": 18,
        "question": "What state do you live in?",
        "response_type": "Radio",
        "answers": [
            {
                "id": 411,
                "answer": "Abuja",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 18
            },
            {
                "id": 412,
                "answer": "Abia",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 18
            },
            {
                "id": 413,
                "answer": "Adamawa",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 18
            },
            {
                "id": 414,
                "answer": "Anambra",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 18
            },
            {
                "id": 415,
                "answer": "Akwa Ibom",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 18
            },
            {
                "id": 416,
                "answer": "Bauchi",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 18
            },
            {
                "id": 417,
                "answer": "Borno",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 18
            },
            {
                "id": 418,
                "answer": "Bayelsa",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 18
            },
            {
                "id": 419,
                "answer": "Cross River",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 18
            },
            {
                "id": 420,
                "answer": "Enugu",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 18
            },
            {
                "id": 421,
                "answer": "Ekiti",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 18
            },
            {
                "id": 422,
                "answer": "Edo",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 18
            },
            {
                "id": 423,
                "answer": "Delta",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 18
            },
            {
                "id": 424,
                "answer": "Gombe",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 18
            },
            {
                "id": 425,
                "answer": "Jigawa",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 18
            },
            {
                "id": 426,
                "answer": "Katsina",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 18
            },
            {
                "id": 483,
                "answer": "Kano",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 18
            },
            {
                "id": 484,
                "answer": "Kaduna",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 18
            },
            {
                "id": 485,
                "answer": "Lagos",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 18
            },
            {
                "id": 486,
                "answer": "Benue",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 18
            },
            {
                "id": 487,
                "answer": "Kogi",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 18
            },
            {
                "id": 488,
                "answer": "Kebbi",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 18
            },
            {
                "id": 489,
                "answer": "Niger",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 18
            },
            {
                "id": 490,
                "answer": "Imo",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 18
            },
            {
                "id": 491,
                "answer": "Ebonyi",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 18
            },
            {
                "id": 492,
                "answer": "Ondo",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 18
            },
            {
                "id": 493,
                "answer": "Oyo",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 18
            },
            {
                "id": 494,
                "answer": "Ogun",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 18
            },
            {
                "id": 495,
                "answer": "Osun",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 18
            },
            {
                "id": 497,
                "answer": "Plateau",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 18
            },
            {
                "id": 498,
                "answer": "Rivers",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 18
            },
            {
                "id": 499,
                "answer": "Sokoto",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 18
            },
            {
                "id": 500,
                "answer": "Taraba",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 18
            },
            {
                "id": 501,
                "answer": "Nasarawa",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 18
            },
            {
                "id": 502,
                "answer": "Yobe",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 18
            },
            {
                "id": 503,
                "answer": "Zamfara",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 18
            },
            {
                "id": 631,
                "answer": "Kwara",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 18
            }
        ]
    },
    {
        "id": 19,
        "question": "What is the highest level of education you have completed?",
        "response_type": "Radio",
        "answers": [
            {
                "id": 427,
                "answer": "No Education At All",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 19
            },
            {
                "id": 428,
                "answer": "Primary School",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 19
            },
            {
                "id": 429,
                "answer": "Secondary School",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 19
            },
            {
                "id": 430,
                "answer": "Vocational/Technical Education",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 19
            },
            {
                "id": 431,
                "answer": "Ond/Pre Degree/Diploma",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 19
            },
            {
                "id": 432,
                "answer": "University (BSc/BA/B.Ed) Or Polytechnic (HND) Graduate",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 19
            },
            {
                "id": 433,
                "answer": "Masters, Professorial, Doctorate, Professional Certification",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 19
            }
        ]
    },
    {
        "id": 20,
        "question": "Into which of the following categories does your monthly personal income fall?",
        "response_type": "Radio",
        "answers": [
            {
                "id": 437,
                "answer": "Student/Dependent",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 20
            },
            {
                "id": 438,
                "answer": "Unemployed/No Earning As At Now",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 20
            },
            {
                "id": 439,
                "answer": "Business Person/Income Not Fixed",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 20
            },
            {
                "id": 440,
                "answer": "N20,000 - N30,000",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 20
            },
            {
                "id": 441,
                "answer": "N31,000 - N40,000",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 20
            },
            {
                "id": 442,
                "answer": "N41,000 - N60,000",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 20
            },
            {
                "id": 443,
                "answer": "N61,000 - N79,000",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 20
            },
            {
                "id": 444,
                "answer": "N80,000 - N99,000",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 20
            },
            {
                "id": 445,
                "answer": "N100,000 - N150,000",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 20
            },
            {
                "id": 446,
                "answer": "N151,000 - N199,000",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 20
            },
            {
                "id": 447,
                "answer": "N200,000 - N300,000",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 20
            },
            {
                "id": 448,
                "answer": "N300,000 - N500,000",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 20
            },
            {
                "id": 449,
                "answer": "N500,000 - N1m",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 20
            },
            {
                "id": 504,
                "answer": "Above N1m",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 20
            }
        ]
    },
    {
        "id": 21,
        "question": "What is your nationality?",
        "response_type": "Dropdown",
        "answers": [
            {
                "id": 450,
                "answer": "Nigerian",
                "answer_title": null,
                "answer_type": "SELECT",
                "sector_id": null,
                "choice": null,
                "question": 21
            },
            {
                "id": 451,
                "answer": "Non-Nigerian",
                "answer_title": null,
                "answer_type": "SELECT",
                "sector_id": null,
                "choice": null,
                "question": 21
            }
        ]
    },
    {
        "id": 22,
        "question": "How did you hear about this survey?",
        "response_type": "Radio",
        "answers": [
            {
                "id": 452,
                "answer": "From Friend, Colleague/Family",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 22
            },
            {
                "id": 453,
                "answer": "Via Whatsapp Group",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 22
            },
            {
                "id": 454,
                "answer": "Via Social Media (Facebook, Twitter, Instagram Etc)",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 22
            },
            {
                "id": 505,
                "answer": "Via Mass Media (Radio, Tv, Newspaper)",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 22
            },
            {
                "id": 506,
                "answer": "Via My Organization",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 22
            }
        ]
    },
    {
        "id": 23,
        "question": "If you wish to have the survey report and other information about the NCSI sent to you via email, kindly input your email address here.",
        "response_type": "Text",
        "answers": []
    },
    {
        "id": 24,
        "question": "Would you like to take another survey?",
        "response_type": "Radio",
        "answers": [
            {
                "id": 462,
                "answer": "Yes",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 24
            },
            {
                "id": 463,
                "answer": "No",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 24
            }
        ]
    },
    {
        "id": 25,
        "question": "Select the sub-sector you want to rate.",
        "response_type": "Radio",
        "answers": [
            {
                "id": 466,
                "answer": "Banking",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 1,
                "choice": "1",
                "question": 25
            },
            {
                "id": 467,
                "answer": "Fintech",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 1,
                "choice": "2",
                "question": 25
            },
            {
                "id": 468,
                "answer": "GSM Provider",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 2,
                "choice": "1",
                "question": 25
            },
            {
                "id": 469,
                "answer": "Internet Service Providers",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 2,
                "choice": "2",
                "question": 25
            },
            {
                "id": 470,
                "answer": "General Insurance",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 3,
                "choice": "1",
                "question": 25
            },
            {
                "id": 471,
                "answer": "Health Management Organizations (HMO)",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 3,
                "choice": "2",
                "question": 25
            },
            {
                "id": 472,
                "answer": "Public Hospitals",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 4,
                "choice": "1",
                "question": 25
            },
            {
                "id": 473,
                "answer": "Private Hospitals",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 4,
                "choice": "2",
                "question": 25
            },
            {
                "id": 474,
                "answer": "Aviation",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 5,
                "choice": "1",
                "question": 25
            },
            {
                "id": 475,
                "answer": "Inter-state Transport",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 5,
                "choice": "2",
                "question": 25
            },
            {
                "id": 476,
                "answer": "Intra-city Transport",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 5,
                "choice": "3",
                "question": 25
            },
            {
                "id": 477,
                "answer": "Hotels, Parks & Resorts",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 9,
                "choice": "1",
                "question": 25
            },
            {
                "id": 478,
                "answer": "Bars, Lounges & Eateries",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 9,
                "choice": "2",
                "question": 25
            },
            {
                "id": 479,
                "answer": "Distribution (Discos)",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 6,
                "choice": "1",
                "question": 25
            },
            {
                "id": 480,
                "answer": "Online Stores",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 7,
                "choice": "1",
                "question": 25
            },
            {
                "id": 481,
                "answer": "Government Agencies",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 8,
                "choice": "1",
                "question": 25
            },
            {
                "id": 482,
                "answer": "Nigeria Missions/Embassies",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 8,
                "choice": "1",
                "question": 25
            },
            {
                "id": 635,
                "answer": "Public universities",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 633,
                "choice": "1",
                "question": 25
            },
            {
                "id": 636,
                "answer": "Private universities",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 633,
                "choice": "2",
                "question": 25
            },
            {
                "id": 637,
                "answer": "Real Estate",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 632,
                "choice": "1",
                "question": 25
            },
            {
                "id": 639,
                "answer": "Sports/Gaming",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": 634,
                "choice": "1",
                "question": 25
            }
        ]
    },
    {
        "id": 26,
        "question": "What frustrates you most with services in the banking sub sector!",
        "response_type": "Radio",
        "answers": [
            {
                "id": 509,
                "answer": "Slow mobile application channels",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 26
            },
            {
                "id": 510,
                "answer": "Long wait time in resolving failed transactions",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 26
            },
            {
                "id": 511,
                "answer": "Long wait time when contacting customer contact centre",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 26
            },
            {
                "id": 512,
                "answer": "Too much unexplainable bank charges",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 26
            }
        ]
    },
    {
        "id": 27,
        "question": "As a customer, what is your biggest frustration when dealing with fintechs?",
        "response_type": "Checkbox",
        "answers": [
            {
                "id": 513,
                "answer": "Lack of much human interaction in filing for complaints and resolution",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 27
            },
            {
                "id": 514,
                "answer": "Way too much web application updates",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 27
            },
            {
                "id": 515,
                "answer": "Not much customer reward/loyalty system",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 27
            },
            {
                "id": 516,
                "answer": "Web apps are device selective",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 27
            }
        ]
    },
    {
        "id": 28,
        "question": "As a customer, what will you most want your GSM provider to do for you as a subscriber?",
        "response_type": "Checkbox",
        "answers": [
            {
                "id": 517,
                "answer": "Improve on quality of calls",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 28
            },
            {
                "id": 518,
                "answer": "Reduce rate of dropped calls",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 28
            },
            {
                "id": 519,
                "answer": "Resolve queries in record time",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 28
            },
            {
                "id": 520,
                "answer": "Improve call in/wait time to call centers",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 28
            }
        ]
    },
    {
        "id": 29,
        "question": "What would you most expect your service provider do for you as a subscriber?",
        "response_type": "Checkbox",
        "answers": [
            {
                "id": 521,
                "answer": "Improve browsing speed and connectivity",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 29
            },
            {
                "id": 522,
                "answer": "Display tariff charge rate at the end of each browse session",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 29
            },
            {
                "id": 523,
                "answer": "Reduce downtime and compensate adequately when such occurs",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 29
            },
            {
                "id": 524,
                "answer": "Reduce tariff charge and improve on customer incentives",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 29
            }
        ]
    },
    {
        "id": 30,
        "question": "What in your opinion could be the reason why Nigerians don’t embrace INSURANCE?",
        "response_type": "MultiCheck",
        "answers": [
            {
                "id": 525,
                "answer": "Lack of prompt payment of claims",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": null,
                "choice": null,
                "question": 30
            },
            {
                "id": 526,
                "answer": "Lack of proper education on insurance and its benefits by the insurance industry",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": null,
                "choice": null,
                "question": 30
            },
            {
                "id": 527,
                "answer": "Lack of transparency and trust in the sector",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": null,
                "choice": null,
                "question": 30
            },
            {
                "id": 528,
                "answer": "Way too much documentation",
                "answer_title": null,
                "answer_type": "CHECKBOX",
                "sector_id": null,
                "choice": null,
                "question": 30
            }
        ]
    },
    {
        "id": 31,
        "question": "What most frustrates you when dealing with HMO’s?",
        "response_type": "Checkbox",
        "answers": [
            {
                "id": 529,
                "answer": "Time frame in corresponding with healthcare facility",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 31
            },
            {
                "id": 530,
                "answer": "Lack of clear knowledge of medical plan and what it covers",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 31
            },
            {
                "id": 531,
                "answer": "Lack of follow up during course of patient care",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 31
            },
            {
                "id": 532,
                "answer": "HMO’s plans generally do not cover the major medical conditions, so it’s basically not useful to me",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 31
            }
        ]
    },
    {
        "id": 32,
        "question": "What in your opinion is the major factor affecting good and quality Medicare at private hospital’s?",
        "response_type": "Checkbox",
        "answers": [
            {
                "id": 533,
                "answer": "Lack of quality trained medical personnel",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 32
            },
            {
                "id": 534,
                "answer": "High cost of accessing Medicare",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 32
            },
            {
                "id": 535,
                "answer": "Wrong and inaccurate medical diagnosis",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 32
            },
            {
                "id": 536,
                "answer": "Not enough access and consulting time with doctors or caregivers",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 32
            }
        ]
    },
    {
        "id": 33,
        "question": "In your opinion, what could you attribute to why citizens will opt not to access Medicare at government/public hospitals?",
        "response_type": "Checkbox",
        "answers": [
            {
                "id": 537,
                "answer": "Too much patients, way fewer doctors and nurses",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 33
            },
            {
                "id": 538,
                "answer": "Lack of empathy and caregiving by nurses and doctors",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 33
            },
            {
                "id": 539,
                "answer": "Not enough consultation time and proper explanation of my ailment",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 33
            },
            {
                "id": 540,
                "answer": "Not up-to-date equipment",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 33
            },
            {
                "id": 541,
                "answer": "Not a patient-friendly environment, especially lavatory facilities",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 33
            }
        ]
    },
    {
        "id": 34,
        "question": "What in your view is the major factor to apathy towards air transportation?",
        "response_type": "Checkbox",
        "answers": [
            {
                "id": 542,
                "answer": "Exorbitant airfares",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 34
            },
            {
                "id": 543,
                "answer": "Not enough confidence in their aircraft maintenance and safety measures",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 34
            },
            {
                "id": 544,
                "answer": "Frequent flight rescheduling/postponement",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 34
            },
            {
                "id": 545,
                "answer": "Not keeping to departure time",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 34
            }
        ]
    },
    {
        "id": 35,
        "question": "What is your biggest challenge with inter-state travels?",
        "response_type": "Checkbox",
        "answers": [
            {
                "id": 546,
                "answer": "Bad road network",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 35
            },
            {
                "id": 547,
                "answer": "Too many police checkpoints/roadblocks that are needless",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 35
            },
            {
                "id": 548,
                "answer": "Insecurity along the highways",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 35
            },
            {
                "id": 549,
                "answer": "Overspeeding and reckless driving",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 35
            }
        ]
    },
    {
        "id": 36,
        "question": "What do you assume to be your biggest drawback commuting within your city?",
        "response_type": "Checkbox",
        "answers": [
            {
                "id": 550,
                "answer": "Traffic congestion",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 36
            },
            {
                "id": 551,
                "answer": "Touting",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 36
            },
            {
                "id": 552,
                "answer": "Unnecessary increase in fares",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 36
            },
            {
                "id": 553,
                "answer": "Unruly drivers, bus assistants, and ground staff",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 36
            }
        ]
    },
    {
        "id": 37,
        "question": "What is citizens major grouse with Disco’s?",
        "response_type": "Checkbox",
        "answers": [
            {
                "id": 554,
                "answer": "Lack of access to prepaid meter",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 37
            },
            {
                "id": 555,
                "answer": "Low power supply but high (estimated) bill",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 37
            },
            {
                "id": 556,
                "answer": "Untrained staff on customer service",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 37
            },
            {
                "id": 557,
                "answer": "High tariff charge",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 37
            }
        ]
    },
    {
        "id": 38,
        "question": "What in your opinion is the reason Nigerians shy away from online businesses?",
        "response_type": "Checkbox",
        "answers": [
            {
                "id": 558,
                "answer": "Difference in product purchased to product delivered",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 38
            },
            {
                "id": 559,
                "answer": "Refund and return process in case of faulty product or money back",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 38
            },
            {
                "id": 560,
                "answer": "Poor delivery timeline",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 38
            },
            {
                "id": 561,
                "answer": "Scams online are rife and our system is not helpful with tracking scammers online",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 38
            }
        ]
    },
    {
        "id": 39,
        "question": "What in your opinion is the KEY factor limiting citizens from doing and engaging with government agencies?",
        "response_type": "Checkbox",
        "answers": [
            {
                "id": 562,
                "answer": "Bureaucratic bottle necks",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 39
            },
            {
                "id": 563,
                "answer": "Bribery & corruption",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 39
            },
            {
                "id": 564,
                "answer": "Inconsistency in policies",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 39
            },
            {
                "id": 565,
                "answer": "Lack of use of technology",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 39
            }
        ]
    },
    {
        "id": 40,
        "question": "What is the most complain or challenge you encounter as a diaspora or citizen abroad from our missions office abroad?",
        "response_type": "Checkbox",
        "answers": [
            {
                "id": 566,
                "answer": "Passport Issuance and renewals",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 40
            },
            {
                "id": 567,
                "answer": "Obtaining NIN",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 40
            },
            {
                "id": 568,
                "answer": "Poor consular assistance when sought",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 40
            },
            {
                "id": 569,
                "answer": "Extortion, racketeering and corrupt practices from embassy staff",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 40
            }
        ]
    },
    {
        "id": 41,
        "question": "Are you resident in Nigeria?",
        "response_type": "Dropdown",
        "answers": [
            {
                "id": 627,
                "answer": "Yes",
                "answer_title": null,
                "answer_type": "SELECT",
                "sector_id": null,
                "choice": null,
                "question": 41
            },
            {
                "id": 628,
                "answer": "No",
                "answer_title": null,
                "answer_type": "SELECT",
                "sector_id": null,
                "choice": null,
                "question": 41
            }
        ]
    },
    {
        "id": 43,
        "question": "What is the bane of the tertiary education sector?",
        "response_type": "Radio",
        "answers": [
            {
                "id": 670,
                "answer": "High school fees",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 43
            },
            {
                "id": 671,
                "answer": "Selling of handouts",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 43
            },
            {
                "id": 672,
                "answer": "Low quality of lecturers",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 43
            },
            {
                "id": 673,
                "answer": "Poor investment in research and infrastructures",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 43
            }
        ]
    },
    {
        "id": 44,
        "question": "What is the biggest complaint you have with betting companies?",
        "response_type": "Radio",
        "answers": [
            {
                "id": 674,
                "answer": "Poor customer centre response time",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 44
            },
            {
                "id": 675,
                "answer": "Delayed payment of winnings",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 44
            },
            {
                "id": 676,
                "answer": "Poor customer bonus incentives",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 44
            }
        ]
    },
    {
        "id": 45,
        "question": "What is your biggest discontent with the real estate sector ?",
        "response_type": "Radio",
        "answers": [
            {
                "id": 677,
                "answer": "Poor quality buildings",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 45
            },
            {
                "id": 678,
                "answer": "Lack of proper legal documentation",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 45
            },
            {
                "id": 679,
                "answer": "Rental fees and duration",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 45
            },
            {
                "id": 680,
                "answer": "Agency fees not properly regulated",
                "answer_title": null,
                "answer_type": "RADIO",
                "sector_id": null,
                "choice": null,
                "question": 45
            }
        ]
    }
]


export default sample;